export default __webpack_public_path__ + "static/icon-3a57099e679d43e54291394bf281610c.svg";